
/** 混入方法 ::: 
 *  @mixin mixFormConfig 表单项属性解构混入
 */
import { mixFormConfig } from "@/mixins/common/mix_form_config.js";
/** 工具方法 ::: 
 *  @function moneyToCapitals 金额转大写
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { moneyToCapitals } from "@/utils/unit_format.js";
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name RenderItemTemplate 子级混入
 *  @author 王汝鹏 
 *  @version 2019-11-30
 */
export const mixRenderItemTemplateChild = {
  mixins: [ mixFormConfig ],
  inject: [ 'render_item_template_store' ],
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} formModels 表单填写内容
     *  @return {Object} formMap 表单项字典
     */
    ...makeComputedGroup("render_item_template_store", {
      formModels: { get: "formModels" },
      formMap: { get: "formMap" }
    }),
    /** @name 当前表单项渲染值 
     *  @return {String} 表单项渲染值
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    renderCurrentModel() {
      // 数组类型，渲染时返回拼接的值
      if (Array.isArray(this.currentModel)) { return this.currentModel.join(' '); }
      // 布尔类型，渲染时返回是、否
      if ((typeof this.currentModel) === 'boolean') { return this.currentModel ? '是' : '否' }
      // 配置了金额转大写规则，返回内容的金额格式
      let { isMoney } = this.validator;
      if (isMoney && this.currentModel && /^\d+(\.\d+)?$/.test(this.currentModel)) { return moneyToCapitals(this.currentModel); }
      // 其它类型值，直接返回
      return this.currentModel;
    },
    /** @name 表单填写内容长度-小写字母按照2个&ensp;计算，中文按照3个&nesp;计算
     *  @return {Number} 表单填写内容长度
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    currentModelLength() {
      let length = 0;
      if (this.renderCurrentModel) {
        let currentModel = this.renderCurrentModel;
        // 半角符号数量
        let smallCharLength = currentModel.replace(/[^\x00-\xff]/g,"").length;
        // 全角符号数量
        let bigCharLength = currentModel.length - smallCharLength;
        // 计算已经输入的符号长度,
        // 苹果系统 半角符号按照2个&ensp;计算，全角符号按照3.5个&ensp;计算 测试稳定
        // windows 半角符号按照1个&ensp;计算，全角符号按照2个&ensp;计算 测试稳定
        length = parseInt(smallCharLength * 1 + bigCharLength * 2);
      }
      return length;
    },
     /** @name 左侧下划线长度
     *  @return {Number} 下划线长度
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    leftUnderlineLength() {
      // 约定下划线规则 1厘米 = 6个&ensp;
      if (this.currentModelLength === 0) return this.underline*3;
      let length = this.underline*6>this.currentModelLength
                    ? Math.ceil((this.underline*6-this.currentModelLength)/2)
                    : 1;
      return length;
    },
    /** @name 右侧下划线长度
     *  @return {Number} 下划线长度
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    rightUnderlineLength() {
      // 约定下划线规则 1厘米 = 6个&ensp;
      if (this.currentModelLength === 0) return this.underline*3;
      let length = this.underline*6>this.currentModelLength
                    ? Math.ceil((this.underline*6-this.currentModelLength)/2)
                    : 1;
      return length;
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/render_item/mix_render_item_template_child.js